import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  singleNews: [],
  relatedArticles: [],
  tagsList: [],
  error: null
};

// ************************* Fetch Single News *************************
const fetchSingleNewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchSingleNewsSuccess = (state = INITIAL_STATE, action) => {
  let newSingleNewsArr;
  if (action.singleNews.postSlug !== null) {
    // console.log('If');
    newSingleNewsArr = [...action.singleNews.singleNews];
  } else {
    // console.log('Else');
    newSingleNewsArr = [...state.singleNews, ...action.singleNews.singleNews];
  }
  return { ...state, singleNews: newSingleNewsArr, loading: false };
};

const fetchSingleNewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false, error: action.error };
};
// _____________________________________________________________________

// ************************* Fetch Related Articles *************************
const fetchRelatedArticlesForSingleNewsStart = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: true };
};

const fetchRelatedArticlesForSingleNewsSuccess = (
  state = INITIAL_STATE,
  action
) => {
  let newRelatedArticles, newTagsList;
  if (
    state.singleNews.length === state.relatedArticles.length + 1 &&
    state.singleNews.length === state.tagsList.length + 1
  ) {
    newRelatedArticles = [
      ...state.relatedArticles,
      [...action.relatedArticles.relatedArticles]
    ];
    newTagsList = [...state.tagsList, [...action.relatedArticles.tagsList]];
  } else {
    newRelatedArticles = [[...action.relatedArticles.relatedArticles]];
    newTagsList = [[...action.relatedArticles.tagsList]];
  }

  return {
    ...state,
    relatedArticles: newRelatedArticles,
    tagsList: newTagsList,
    loading: false
  };
};

const fetchRelatedArticlesForSingleNewsFailure = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_SINGLE_NEWS_START]: fetchSingleNewsStart,
  [Types.FETCH_SINGLE_NEWS_FAILURE]: fetchSingleNewsFailure,
  [Types.FETCH_SINGLE_NEWS_SUCCESS]: fetchSingleNewsSuccess,

  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_NEWS_START]: fetchRelatedArticlesForSingleNewsStart,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_NEWS_FAILURE]: fetchRelatedArticlesForSingleNewsFailure,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_NEWS_SUCCESS]: fetchRelatedArticlesForSingleNewsSuccess
};

// Create and Export Reducer
export const singleNewsReducer = createReducer(INITIAL_STATE, HANDLERS);
